import React from 'react';
import styles from './ItemCard.module.css';
import { useTranslation } from 'react-i18next';
import { formattedTravelTime } from 'components/Map/util';

interface TravelTimeProps {
  estimatedTime: string;
}

export const TravelTime: React.FC<TravelTimeProps> = ({ estimatedTime }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.durationContainer}>
      {estimatedTime !== '-' && (
        <div className={styles.estimatedTime}>
          <img src="/static/images/map/walker_black.svg" className={styles.clockIcon} alt="" />
          <div>{formattedTravelTime(estimatedTime, t)}</div>
        </div>
      )}
    </div>
  );
};
